module.exports = __webpack_public_path__ + "static/media/horizontal.c00290e4.svg";